import {
  SectionItem,
  SectionItemEmptyState,
} from "@/features/tasks/SectionItem";
import { type Opportunity } from "@repo/api";
import { ListView, ListViewItem, Skeleton } from "@repo/skapa";
import { t } from "@repo/translation";
import { hasItems } from "@repo/utils";

import { useNBADetails } from "./getNBAdetails";

interface NextBestActionsProps {
  opportunity: Opportunity;
  editable?: boolean;
}

export const NextBestActions = ({
  opportunity,
  editable,
}: NextBestActionsProps) => {
  const { isLoading, actions } = useNBADetails(opportunity);

  return (
    <SectionItem title={t("label.next_best_actions")}>
      <>
        {isLoading && <Skeleton height="72px" />}
        {hasItems(actions) ? (
          <ListView id="upcoming-tasks-list">
            {actions.map((action) => (
              <ListViewItem
                inset
                key={action.id}
                leadingIcon={action.icon}
                control={editable ? "navigational" : "default"}
                onClick={editable ? action.onClick : undefined}
                title={action.title}
              />
            ))}
          </ListView>
        ) : (
          <SectionItemEmptyState title={t("prompt.no_next_best_actions")} />
        )}
      </>
    </SectionItem>
  );
};
